import React, {useCallback, useState} from 'react';
import {ApiSelect, Relative} from "react-admin-base-bootstrap";
import {useFreeFetch} from 'react-admin-base';
import UserEntity from '../pages/User/UserEntity';

export function CreateSelect(props) {
    const { Component, onChange, value, isMulti } = props;

    const [ isOpen, setIsOpen ] = useState(false);

    const onReload = useCallback(function(data) {
        setIsOpen(false);
        data && onChange(isMulti ? (value || []).concat([data]) : data);
    }, [onChange, setIsOpen, value, isMulti]);

    return <>
        { isOpen && <Component id={value && value.id} onReload={onReload} /> }
        <ApiSelect {...props} onAddOrEdit={() => setIsOpen(true)} />
    </>;
}

export function FreeSelect(props) {
    const { value, onChange, options, isMulti } = props;
    
    const onCreateOption = useCallback(function (input) {
        return {
            id: input,
            name: input
        };
    }, []);
    
    const fnc = a => ({ id: a, name: a });
    
    return <ApiSelect
        {...props}
        value={isMulti ? (value || []).map(fnc) : (value && fnc(value))}
        onChange={a => onChange((a && (isMulti ? a.map(a => a.id) : a.id))) || null}
        staticOptions={(options && options.map(fnc)) || []}
        onCreateOption={onCreateOption}
    />;
}

export function MapSelect(props) {
    const { value, onChange, staticOptions } = props;

    return <ApiSelect
        {...props}
        staticOptions={Object.entries(staticOptions).map(a => ({ id: +a[0], name: a[1] }))}
        value={value && { id: +value, name: staticOptions[value] }}
        onChange={a => onChange(a && a.id)}
    />;
}

export function UserSelect(props) {
    return <CreateSelect
        Component={UserEntity}
        url="/user"
        filterOption={_ => true}
        {...props}
    />;
}

export function CountrySelect(props) {
    const [ countries ] = useFreeFetch('/country?itemPerPage=-1');
    
    return <ApiSelect
        /*url="/country?itemPerPage=-1"*/
        {...props}
        staticOptions={countries && countries.data}
    />;
}

export function LanguageSelect(props) {
    return <ApiSelect url="/language" {...props}>
        { row => <>
            { row.icon && <Relative>
                <img style={{ width: '16px', height: '16px', marginRight: '5px' }} src={row.icon.access_url} alt={row.name} />
            </Relative> }
            { row.name }
        </>}
    </ApiSelect>;
}

